import { objectValues } from '@hsp/utilities';

import { Uri } from 'constants/uri';
import { IResult } from 'types/api/common';
import { ICriteriaFile } from 'types/api/file';

import { BaseHttpService } from './http/base-http.service';

class FileService extends BaseHttpService {
  constructor() {
    super({ endpoints: objectValues(Uri.File) as string[] });
  }

  uploadCriteria(file: File, formData: FormData, cancel = false): Promise<IResult<ICriteriaFile>> {
    const url = Uri.File.Criteria;

    return this.upload(file, { formData }, this.defaultRequestConfig(url, cancel));
  }
}

export const fileService = new FileService();
